module.exports = __webpack_public_path__ + "assets/img/AdditionReward_tit.06a8830c.png";